import React from "react";
import AppLink from "../../../../components/AppLink";
import { IconArrowRight } from "../../../../icons";
import DocsNiceToKnow from "../../shared/DocsNiceToKnow";
import DocsPreviewPanel from "../../shared/DocsPreviewPanel";
import DocsSectionCard from "../../shared/DocsSectionCard";

const sizeItems = [
  { size: "xs", label: "XS", fontSize: "12px" },
  { size: "sm", label: "SM", fontSize: "13px" },
  { size: "md", label: "MD", fontSize: "14px" },
  { size: "lg", label: "LG", fontSize: "16px" },
];

const niceToKnowItems = [
  "Leading- und Trailing-Icon sind optional.",
  "Icon-Grösse kommt direkt von Link-Grösse.",
  "Typischerweise in Footer von Cards, Dialogen, etc.",
];

function preventNavigation(event) {
  event.preventDefault();
}

function LinkSizeRow({ item }) {
  return (
    <div className="ds-docs-link-size-row">
      <div className="ds-docs-link-size-row__label">
        {item.label} / {item.fontSize}
      </div>
      <AppLink href="#" size={item.size} trailingIcon={<IconArrowRight />} onClick={preventNavigation}>
        Weiterleiten
      </AppLink>
    </div>
  );
}

export default function LinksDocs() {
  return (
    <DocsSectionCard title="Links">
      <div className="ds-docs-spotlight-grid">
        <DocsPreviewPanel>
          <div className="ds-docs-preview-surface ds-docs-link-preview">
            {sizeItems.map((item) => (
              <LinkSizeRow key={item.size} item={item} />
            ))}
          </div>
        </DocsPreviewPanel>

        <DocsNiceToKnow items={niceToKnowItems} />
      </div>
    </DocsSectionCard>
  );
}
